module.exports = "/assets/data/ed523750645117af3bdbb770fe571355-LA18.data.json";